import styles from './UserAccount.less';
import React, { Component, PropTypes } from 'react';
import { ChevronIcon } from 'seek-style-guide/react';
import { ScreenReaderOnly } from 'seek-style-guide/react';
import UserAccountMenu from 'UserAccountMenu/UserAccountMenu';

class UserAccount extends Component {

  static propTypes = {
    userDisplayName: PropTypes.string.isRequired,
    userReady: PropTypes.bool.isRequired
  };

  render() {
    const { userDisplayName, userReady } = this.props;

    return (
      <nav data-automation="user-account" className={`${styles.root} ${userReady ? styles.root_isReady : ''}`}>

        <ScreenReaderOnly>
          <h1>User menu</h1>
        </ScreenReaderOnly>

        <input id="user-account-menu-toggle" autoComplete="off" className={styles.toggle} type="checkbox" />

        <div className={styles.menuBackdrop}>
          <label
            data-automation="user-account-menu-backdrop"
            htmlFor="user-account-menu-toggle"
            className={styles.menuBackdropLabel}>
            <ScreenReaderOnly>Show user menu</ScreenReaderOnly>
          </label>
        </div>

        <label data-automation="user-account-menu-toggle" className={styles.toggleLabel} htmlFor="user-account-menu-toggle">
          <ScreenReaderOnly>Show user menu: </ScreenReaderOnly>
          <span className={styles.userDisplayName} data-automation="user-account-name" data-hj-masked={true}>{ userDisplayName }</span>
          <ChevronIcon direction="down" className={styles.chevron} svgClassName={styles.chevronSvg} />
        </label>

        <div className={styles.toggleContainer}>
          <UserAccountMenu />
        </div>

      </nav>
    );
  }

}

export default UserAccount;



/** WEBPACK FOOTER **
 ** ./app/components/Header/components/UserAccount/UserAccount.js
 **/